import React, {useState, useContext} from 'react';
import {Grid, InputLabel} from "@material-ui/core";
import {Form, Alert, FormSelect, ComboSelect, CheckboxEditor, MaskedNumber, MaskedText} from '../../../../controls';
import SystemContext from "../../../../SystemContext";
import GeneralChecklistItemsValidator from "../../validators/GeneralChecklistItemsValidator";
import { useUpdateComboValue } from "../../../../services/settings";

const ComboDetailsForm = (_props) => {
  const props = {
    canEdit: false,
    ..._props
  }

  const defaultRecord = {
    "checklistStatusType": "DEFAULT",
    "allowNotes": false
  };

  const classes = props.classes;
  const [comboRecord, setComboRecord] = useState(props.comboRecord);
  const [record, setRecord] = useState({...defaultRecord, ...(props.comboRecord?props.comboRecord.data:null)});
  const [editing, setEditing] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    severity: "error",
    message: ""
  });

  if (props.comboRecord && (props.comboRecord.comboValueUuid !== comboRecord.comboValueUuid)) {
    setRecord(props.comboRecord.data);
    setComboRecord(props.comboRecord);
    setEditing(false);
  }

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  const handleUpdateComboValue = useUpdateComboValue();

  const extraKeys = [];

  // const handleRecordsChanged = async (changeData, props) => {
  //   const {recordChange} = props;
  //   const {record, resolve, reject} = changeData;
  //   try {
  //     const changes = __.pick(record, ['type', 'records']);
  //     await recordChange(changes, true);
  //     resolve();
  //   } catch (err) {
  //     reject();
  //   }
  // }

  // const handleAddRecord = () => {
  //   if (eventBus) {
  //     eventBus.trigger('Combos.GeneralChecklistItemsFormFields.AddRecord');
  //   }
  // }

  return (
    <div key="formContainer" style={{width: "100%", textAlign:"left"}}>
      <Alert
        key="alert"
        onChange={(open) => {
          setAlert({ ...alert, open })
        }}
        open={alert.open}
        severity={alert.severity}
        message={alert.message}
        timeOut={alert.timeOut || 0}
      />
      {record ?
      <Form key="form"
        message=""
        open={true}
        record={record}
        validator={editing?GeneralChecklistItemsValidator:null}
        formBodyStyle={{maxHeight: "calc(100vh - 320px)"}}
        buttonBarStyleOverride={{position: "relative", width: "calc(100% - 30px)", marginTop: -30}}
        buttons = {editing?
          {
            // addRecord: {icon: "add_circle", key: "Add Sector", label: "Add", color: "primary"},
            save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
          }: props.canEdit?{
            edit: {icon: "edit", key: "Edit", label: "Edit", color: "primary"}
          }: {}
        }

        onChange={(state) => {
          if (state.buttonPressed === "edit" && props.canEdit) {
            setEditing(true);
          }
          if (state.buttonPressed === "cancel") {
            setEditing(false);
            setRecord({...defaultRecord, ...(props.comboRecord?props.comboRecord.data:null)});
          }
          if (state.buttonPressed === "save") {
            SystemData.toggleLoadingProgress(true);
            const record = state.record;
            handleUpdateComboValue.mutate({
              extraKeys,
              record: {...comboRecord, data: {...record}},
              postSuccess: () => {
                setEditing(false);
                SystemData.toggleLoadingProgress(false);
                setAlert({ severity: "info", open: true, message: "Record Updated", timeOut: 5 });
              },
              postError: (data) => {
                SystemData.toggleLoadingProgress(false);
                if (data.errorMessage) {
                  SystemData.alert("Error", `${data.errorMessage}`);
                } else {
                  SystemData.alert("Error", `An Unexpected Error has occurred creating the Combo Details.`);
                }
              }
            });
          // } else if (state.buttonPressed === "addRecord") {
          //   handleAddRecord();
          } else {
          }
        }}
      >
        <Grid container checkChildren={true} spacing={3}>
          <Grid item xs={3} checkChildren={true}>
            <InputLabel shrink id={`checklistStatusType-label`} style={{position: "relative"}} >Checklist Status Type</InputLabel>
            <ComboSelect
              id="checklistStatusType"
              // label="Checklist Status Type"
              group='GENERAL CHECKLIST STATUS'
              subGroup=''
              readOnly={editing!==true}
            />
          </Grid>
          <Grid item xs={1} checkChildren={true}>
            <CheckboxEditor
              id="allowNotes"
              label="Allow Notes"
              readOnly={editing!==true}
            />
          </Grid>
          <Grid item xs={1} checkChildren={true}>
            {comboRecord?.subGroup === "CLEAN FLIGHT"
              ?
                <CheckboxEditor
                  id="IncludeForFerryFlight"
                  label="Ferry Flights"
                  readOnly={editing!==true}
                />
              :null
            }
          </Grid>
          <Grid item xs={1} checkChildren={true}>
            {comboRecord?.subGroup === "CLEAN FLIGHT"
              ?
                <MaskedNumber
                  id="cutOffValue"
                  label="Cut Off Time Offset"
                  inputLabelProps={{shrink: true}}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  readOnly={editing!==true}
                />
              :null
            }
          </Grid>
          <Grid item xs={1} checkChildren={true}>
            {comboRecord?.subGroup === "CLEAN FLIGHT"
              ?
                <FormSelect
                  id="cutOffUnit"
                  label="Cut Off Time Unit"
                  options={[{code: "hours", value: "Hours"}, {code: "minutes", value: "Minutes"}, {code: "days", value: "Days"}]}
                  readOnly={!editing}
                  style={{marginTop: "3px"}}
                  fullWidth
                  // onChange={(value, props) => {
                  //   props.recordChange({...props.record, direction: value, validFrom: null, validTo: null, validTimeFrom: '00:00', validTimeTo: '23:59', days: "1234567"});
                  // }}
                />
              :null
            }
          </Grid>
          <Grid item xs={1} checkChildren={true}>
            {comboRecord?.subGroup === "CLEAN FLIGHT"
              ?
                <FormSelect
                  id="cutOffBias"
                  label="Offset"
                  options={[{code: "BEFORE", value: "BEFORE"}, {code: "AFTER", value: "AFTER"}]}
                  readOnly={!editing}
                  style={{marginTop: "3px"}}
                  fullWidth
                  // onChange={(value, props) => {
                  //   props.recordChange({...props.record, direction: value, validFrom: null, validTo: null, validTimeFrom: '00:00', validTimeTo: '23:59', days: "1234567"});
                  // }}
                />
              :null
            }
          </Grid>
          <Grid item xs={1} checkChildren={true}>
            {comboRecord?.subGroup === "CLEAN FLIGHT"
              ?
                <FormSelect
                  id="relativeTo"
                  label="Relative To"
                  options={[{code: "STD", value: "STD"}, {code: "ETD", value: "ETD"}]}
                  readOnly={!editing}
                  style={{marginTop: "3px"}}
                  fullWidth
                  // onChange={(value, props) => {
                  //   props.recordChange({...props.record, direction: value, validFrom: null, validTo: null, validTimeFrom: '00:00', validTimeTo: '23:59', days: "1234567"});
                  // }}
                />
              :null
            }
          </Grid>
          <Grid item xs={1} checkChildren={true}>
            {comboRecord?.subGroup === "CLEAN FLIGHT"
              ?
              <CheckboxEditor
                id="resetOnReschedule"
                label="Reset Checklist"
                readOnly={editing!==true}
              />
              :null
            }
          </Grid>
          <Grid item xs={1} checkChildren={true}>
            {comboRecord?.subGroup === "CLEAN FLIGHT"
              ?
              <MaskedNumber
                id="resetDelay"
                label="Reset After (Hours)"
                inputLabelProps={{shrink: true}}
                decimalScale={1}
                fixedDecimalScale={true}
                readOnly={editing!==true}
              />
              :null
            }
          </Grid>
          <Grid item xs={12} checkChildren={true}>
            {comboRecord?.subGroup === "CLEAN FLIGHT"
              ?
                <div>
                  <InputLabel shrink id={`tooltip-label`} style={{position: "relative"}} >Tooltip</InputLabel>
                  <MaskedText
                    id="tooltip"
                    // label="Tooltip"
                    mask={"x".repeat(250)}
                    // style={{ fontSize: "0.875rem"}}
                    readOnly={!editing}
                    inputLabelProps={{shrink: true, top: -10}}
                    fullWidth
                  />
                </div>
              :null
            }
          </Grid>
        </Grid>
      </Form>
      :<></>
    }
    </div>
  );
}

export default ComboDetailsForm;
